import functions from '../functions.js';

class Calendar {

    availabilityMask = null;
    minStay = null;
    translations = null;
    containerClass = null;
    today = null;
    yesterday = null;
    config = {};
    defaults = {
        availabilityMask: '',
        minStay: '',
        translations: {},
        containerClass: '',
        dateFormat: "Y-m-d",
        showMonths: 3,
        nextArrow: '<i class="las la-arrow-right la-lg"></i>',
        prevArrow: '<i class="las la-arrow-left la-lg"></i>',

        checkOutClass: 'checkOutAllowed',
        checkOutOnlyClass: 'checkOutOnlyAllowed',
        checkInClass: 'checkInAllowed',
        notAvailableClass: 'notAvailable',
        notArrivalDepartureClass: 'disabled',
        notMinStayClass: 'disabled',

        mode: 'range',
        rangeSeparator: ' - ',

        defaultDate: [],
        minDate: 'today',
        inline: true,
        altInput: true,
        wrap: false,
        altFormat: "j.m.Y",
    };

    constructor($elem, config, callback) {

        this.config = $.extend({}, this.defaults, config);
        this.config.minStay = this.config.minStay.split(',');

        this.today = new Date();
        this.today.setHours(0,0,0,0);

        this.yesterday = new Date(this.today.getTime());
        this.yesterday.setDate(this.yesterday.getDate() - 1);

        if(functions.isMobile()) {
            this.config.showMonths = 1;
        }

        let flatpickr = $elem.flatpickr({

            altInput: this.config.altInput,
            wrap: this.config.wrap,
            altFormat: this.config.altFormat,
            dateFormat: this.config.dateFormat,
            disableMobile: true,
            mode: this.config.mode,
            minRange: 0,
            showMonths: this.config.showMonths,
            inline: this.config.inline,
            defaultDate: this.config.defaultDate,
            minDate: this.config.minDate,
            onDayCreate: (dObj, dStr, fp, dayElem) => {

                let status = this.getStatus(dayElem.dateObj);
                //let status = 'A';

                if (status == 'N')
                {
                    this.setDayNonAvailable(dayElem);
                    return;
                }
                else if (status == 'A')
                {

                }
                else if (status == 'S')
                {
                    this.setDayNotArrivalPossible(dayElem);
                }
                else if (status == 'D')
                {
                    this.setDayCheckOutOnlyAvailable(dayElem);
                }
                else if (status == 'I')
                {
                    dayElem.className += ' ' + this.config.checkInClass;
                }
                else if (status == 'O')
                {
                    this.setDayCheckOutAvailable(dayElem);
                }

                let onlyCheckInSelected = fp.selectedDates[0] && ! fp.selectedDates[1];

                if (onlyCheckInSelected) {

                    // CHECK MIN STAY
                    let minStay = this.getMinStay(fp.selectedDates[0]);

                    if (minStay) {
                        // get difference between selected and current date of the loop
                        // check if min stay is met - skip selected date
                        let diff = this.dateDiff(dayElem.dateObj, fp.selectedDates[0]);
                        if (Math.abs(diff) < minStay) {
                            this.setDayNotMinStay(dayElem, diff, minStay);
                        }
                    }

                    fp.calendarContainer.classList.add('selection');

                    if (+dayElem.dateObj != +fp.selectedDates[0] && ! this.isAvailable(dayElem.dateObj, fp.selectedDates[0])) {
                        this.setDayNotAllowedRange(dayElem);
                        return;
                    }

                    if (dayElem.dateObj.getTime() < fp.selectedDates[0].getTime()) {
                        this.setDayNotAllowedRange(dayElem);
                    } else {
                        this.removeNotAllowedRange(dayElem);
                    }

                } else {
                    fp.calendarContainer.classList.remove('selection');
                }
            },
            onChange: (selectedDates, dateStr, instance) => {
                //callback(this.getDateFrom(selectedDates), this.getDateTo(selectedDates));
            },
            onReady: (selectedDates, dateStr, instance) => {

                if (this.config.containerClass) {
                    let classList = instance.calendarContainer.classList;
                    let classes = this.config.containerClass.split(' ');
                    classes.forEach(function (css_class, index) {
                        classList.add(css_class);
                    });
                }
            },

            nextArrow: this.config.nextArrow,
            prevArrow: this.config.prevArrow,
            locale: {
                rangeSeparator: this.config.rangeSeparator
            }
        });

        return flatpickr;
    };

    getDateFrom(selectedDates) {
        if ( ! selectedDates[0]) return null;
        if ( ! selectedDates[1]) return selectedDates[0];

        return selectedDates[0] < selectedDates[1] ? selectedDates[0] : selectedDates[1];
    };
    getDateTo(selectedDates) {
        if ( ! selectedDates[1]) return null;

        return selectedDates[0] < selectedDates[1] ? selectedDates[1] : selectedDates[0];
    };
    isAvailable(from, to) {

        if ( ! to) {
            to = this.addDate(this.cleanDate(from), 1);
        }

        let dateFrom = from < to ? from : to;
        let dateTo = to > from ? to : from;

        if (dateFrom < this.yesterday) {
            return false;
        }

        if ( ! this.config.availabilityMask) return false;

        let diff = this.dateDiff(dateFrom, this.today);
        let dateToDiff = (diff + this.dateDiff(dateTo, dateFrom));
        let mask = '' + this.config.availabilityMask.substring(diff, dateToDiff);

        return mask ? mask.indexOf('0') === -1 : false;
    };
    getStatus(from, to) {

        if ( ! to) {
            to = this.addDate(this.cleanDate(from), 1);
        }

        let dateFrom = from < to ? from : to;
        let dateTo = to > from ? to : from;

        if (dateFrom <= this.yesterday) {
            return 'N';
        }

        if ( ! this.config.availabilityMask) return 'N';

        let diff = this.dateDiff(dateFrom, this.today);
        let dateToDiff = (diff + this.dateDiff(dateTo, dateFrom));
        let mask = '' + this.config.availabilityMask.substring(diff, dateToDiff);

        return mask;
    };
    addDate(date, days) {
        date = this.cleanDate(date);
        date.setDate(date.getDate() + days)
        return date;
    };
    formatDate(date) {
        function pad(s) { return (s < 10) ? '0' + s : s; }
        let d = new Date(date);
        return [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('.')
    };
    dateDiff(from, to) {
        let f = Date.UTC(from.getFullYear(), from.getMonth()+1, from.getDate());
        let t = Date.UTC(to.getFullYear(), to.getMonth()+1, to.getDate());

        return Math.round((from - to) / (1000 * 60 * 60 * 24));
    };
    setDayCheckOutAvailable(dayElem) {
        dayElem.className += ' ' + this.config.checkOutClass;
    };
    setDayCheckOutOnlyAvailable(dayElem) {
        dayElem.className += ' ' + this.config.checkOutOnlyClass;
    };
    setDayNonAvailable(dayElem) {

        dayElem.className += ' ' + this.config.notAvailableClass;

        $(dayElem).tooltip({
            title: this.config.translations.not_available || ''
        });
    };
    setDayNotArrivalPossible(dayElem) {
        dayElem.className += ' flatpickr-disabled ' + this.config.notArrivalDepartureClass;
        $(dayElem).tooltip({
            title: this.config.translations.not_arrival_day || '',
            trigger: 'hover'
        });
    };
    setDayNotDeparturePossible(dayElem) {
        dayElem.className += ' flatpickr-disabled ' + this.config.notArrivalDepartureClass;
        $(dayElem).tooltip({
            title: this.config.translations.not_departure_day || ''
        });
    };
    setDayNotMinStay(dayElem, diff, minStay) {
        dayElem.className += ' flatpickr-disabled ' + this.config.notMinStayClass;
        if (diff) {
            $(dayElem).tooltip({
                title: this.config.translations.min_stay_is && this.config.translations.min_stay_is.replace('{$min_stay}', minStay) || ''
            });
        }
    };
    setDayNotAllowedRange(dayElem) {

        dayElem.className += ' notAllowedRange';

        $(dayElem).tooltip({
            title: ''
        });
    };
    removeNotAllowedRange(dayElem) {
        dayElem.className = dayElem.className.replace(' notAllowedRange', '');
    };
    getMinStay(date) {

        if ( ! this.config.minStay.length) return 0;

        let diff = this.dateDiff(date, this.today);

        return this.config.minStay[diff] || 0;

    };
    cleanDate(date) {
        date = new Date(date);
        date.setHours(0);
        date.setMinutes(0);
        date.setSeconds(0);
        date.setMilliseconds(0);
        return date;
    }
}
export {
    Calendar
}